import React from "react";
import { Form } from "react-crud-form";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import { Input } from "ui/components/input";
import { useNavigate } from "react-router-dom";
import { kekaSchema } from "./schema";
import { FormActions } from "components/form/actions";
import { PermissionControlledInput } from "permissions/components/input";
import { FormLabel } from "components/form";
import { useKekaForm } from "./useKekaform";

const KekaForm = ({ kekaId }) => {
  const navigate = useNavigate();
  const { form, handleCreate, handleUpdate, handleRead } = useKekaForm({
    kekaId,
  });

  return (
    <Form
      form={form}
      create={handleCreate}
      update={handleUpdate}
      read={handleRead}
      itemId={kekaId || "+"}
      schema={kekaSchema}
    >
      {({
        isCreating,
        createItem,
        isNewItem,
        updateItem,
        isUpdating,
        isDirty,
      }) => (
        <div className="space-y-6">
          {/* Client ID */}
          <FormField
            control={form.control}
            name="client_id"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="keka_integrations"
                  type="form"
                >
                  <FormLabel required>Client ID</FormLabel>
                  <Input {...field} />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          {/* Client Secret */}
          <FormField
            control={form.control}
            name="client_secret"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="keka_integrations"
                  type="form"
                >
                  <FormLabel required>Client Secret</FormLabel>
                  <Input {...field} />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          {/* API Key */}
          <FormField
            control={form.control}
            name="api_key"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="keka_integrations"
                  type="form"
                >
                  <FormLabel required>API Key</FormLabel>
                  <Input {...field} />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          {/* Base URL */}
          <FormField
            control={form.control}
            name="base_url"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="keka_integrations"
                  type="form"
                >
                  <FormLabel required>Base URL</FormLabel>
                  <Input {...field} />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormActions
            isNewItem={isNewItem}
            isCreating={isCreating}
            isUpdating={isUpdating}
            isDirty={isDirty}
            createItem={() => createItem().then(() => navigate(-1))}
            updateItem={() => updateItem().then(() => navigate(-1))}
            showCancel={false}
            collection="keka_integrations"
            rule={isNewItem ? "create:*" : "update:*"}
          />
        </div>
      )}
    </Form>
  );
};

export default KekaForm;
